import React, { useEffect, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export interface TOCItem {
  id: string;
  number: number;
  title: string;
}
interface PrivacyTOCProps {
  items: TOCItem[];
}
export function PrivacyTOC({
  items
}: PrivacyTOCProps) {
  const [activeId, setActiveId] = useState<string>(items[0]?.id ?? '');
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(e => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) {
        setActiveId(visible[0].target.id);
      }
    }, {
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    });
    items.forEach(item => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [items]);
  return <>
      {/* Mobile TOC */}
      <div className="lg:hidden mb-10 bg-white rounded-xl shadow-subtle border border-slate-light/50" data-id="element-192">
        <button onClick={() => setMobileOpen(!mobileOpen)} className="w-full flex items-center justify-between px-6 py-5 text-left" aria-expanded={mobileOpen} data-id="element-193">
          <span className="font-sans text-lg font-semibold text-navy" data-id="element-194">
            Table of Contents
          </span>
          <ChevronDownIcon className={`w-5 h-5 text-sky transition-transform ${mobileOpen ? 'rotate-180' : ''}`} strokeWidth={2} data-id="element-195" />
        </button>
        {mobileOpen && <nav className="px-6 pb-6 border-t border-slate-light/60 pt-4" data-id="element-196">
            <ol className="space-y-3" data-id="element-197">
              {items.map(item => <li key={item.id} data-id="element-198">
                  <a href={`#${item.id}`} onClick={() => setMobileOpen(false)} className={`flex items-baseline gap-3 text-[15px] transition-colors ${activeId === item.id ? 'text-sky font-semibold' : 'text-slate hover:text-sky'}`} data-id="element-199">
                    <span className="font-medium text-stone w-6 shrink-0 text-sm" data-id="element-200">
                      {String(item.number).padStart(2, '0')}
                    </span>
                    <span data-id="element-201">{item.title}</span>
                  </a>
                </li>)}
            </ol>
          </nav>}
      </div>

      {/* Desktop TOC */}
      <aside className="hidden lg:block" data-id="element-202">
        <div className="sticky top-28" data-id="element-203">
          <p className="font-sans text-sm font-semibold text-stone mb-5 uppercase" style={{
          letterSpacing: '0.08em'
        }} data-id="element-204">
            On this page
          </p>
          <nav data-id="element-205">
            <ol className="space-y-3 border-l border-slate-light pl-5" data-id="element-206">
              {items.map(item => {
              const isActive = activeId === item.id;
              return <li key={item.id} className="relative" data-id="element-207">
                    {isActive && <span className="absolute -left-[21px] top-1/2 -translate-y-1/2 w-[3px] h-5 bg-sky rounded-full" aria-hidden="true" data-id="element-208" />}
                    <a href={`#${item.id}`} aria-current={isActive ? 'true' : undefined} className={`flex items-baseline gap-3 text-[14px] leading-snug transition-colors ${isActive ? 'text-sky font-semibold' : 'text-slate hover:text-navy'}`} data-id="element-209">
                      <span className={`w-5 shrink-0 text-xs font-medium ${isActive ? 'text-sky' : 'text-stone'}`} data-id="element-210">
                        {String(item.number).padStart(2, '0')}
                      </span>
                      <span data-id="element-211">{item.title}</span>
                    </a>
                  </li>;
            })}
            </ol>
          </nav>
        </div>
      </aside>
    </>;
}